// extracted by mini-css-extract-plugin
export default {"infoPanel":"CPUManagementAssign_infoPanel__XqLDW","searchBox":"CPUManagementAssign_searchBox__Cuyso"};